module.exports = __webpack_public_path__ + "static/assets/af3d919c06d5a26bf0c0a750b810ddce.gif";